import { Award } from "lucide-react";

interface Achievement {
  title: string;
  date?: string;
  description?: string;
}

interface DriverAchievementsProps {
  achievements: Achievement[];
}

export function DriverAchievements({ achievements }: DriverAchievementsProps) {
  if (achievements.length === 0) return null;

  return (
    <div className="space-y-3">
      <h2 className="font-display text-xl font-bold uppercase tracking-tight text-foreground">
        Achievements
      </h2>
      <div className="grid gap-3 sm:grid-cols-2">
        {achievements.map((achievement, i) => (
          <div
            key={i}
            className="flex items-start gap-3 rounded-lg border border-border/50 bg-card/50 p-4 backdrop-blur-sm"
          >
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-folk-orange/10">
              <Award className="h-4 w-4 text-folk-orange" />
            </div>
            <div className="min-w-0">
              <p className="font-semibold text-foreground">{achievement.title}</p>
              {achievement.date && (
                <p className="text-xs text-muted-foreground">{achievement.date}</p>
              )}
              {achievement.description && (
                <p className="mt-1 text-sm text-muted-foreground">{achievement.description}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
